import React, { useContext } from 'react'
import LinePicker from '../LinePicker'
import { getPropertyName } from '../../../../helpers/property'
import { AppConfigContext } from '../../../../context/AppConfig'

function MobileHeader({ className = '', showLinePill, property, selectedPlan, selectedLine, onLineSelected, onFloorPlanSelected }) {
  const { hide_line } = useContext(AppConfigContext)
  return (
    <div
      className={`h-[70px] max-h-[70px] overflow-y-hidden bg-[white] px-[24px] py-[12px] flex items-center justify-between relative shadow-lg ${className}`}
    >
      <div className="flex h-full items-center flex-1">
        <div className="flex-1">
          <span className="font-semibold text-[16px]">{getPropertyName(property.property_name)}</span>
        </div>
      </div>
      {!hide_line && showLinePill && <LinePicker
        mobile
        onLineSelected={onLineSelected}
        onFloorPlanSelected={onFloorPlanSelected}
        selectedPlan={selectedPlan}
        selectedLine={selectedLine}
        property={property}
      />}
    </div>
  )
}

export default MobileHeader
